import axios from "axios";

export default {
    pages: {
        fetchPage: (pageUrl) =>
          axios.get(pageUrl).then(res => res.data)
    },
    reviewTool: {
        fetchStandards: () =>
          axios({
              method: 'GET',
              url: 'https://tool.ayacancernetwork.org.nz/api/standardofcare',
          }).then(res => res.data)
    },
    init: {
        fetchInit: () =>
          axios.get("/api/init").then(res => res.data),
        fetchRoutes: () =>
          axios.get("/api/routes").then(res => res.data),
    },
    forms: {
        submitForm: (data) => {
            return axios({
                method: 'POST',
                url: '/contact-us',

                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                data
            }).then(data => {
            })
        }
    }
}




// WEBPACK FOOTER //
// ./src/api.js